import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { programmeRequest, rowsOf } from './programmeApi';
import ProgrammeSignIn from './ProgrammeSignIn';

function HomeContent({ onSessionExpired }) {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    programmeRequest('/api/programmes').then(data => setList(rowsOf(data))).catch(err => {
      setError(err.message);
      if (err.status === 401) onSessionExpired();
    });
  }, [onSessionExpired]);
  async function create(event) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      const result = await programmeRequest('/api/programmes', {
        method: 'POST',
        body: { deceasedName: name, title: 'Order of Service', audioMode: 'off' },
      });
      navigate(`/programme/edit/${result?.id ?? result?.programme?.id}`);
    } catch (err) {
      setError(err.message);
      if (err.status === 401) onSessionExpired();
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className="min-h-screen bg-brand-light pt-28 pb-12 px-4">
      <div className="max-w-3xl mx-auto">
        <h1 className="font-serif text-3xl font-bold text-accent-navy">Service Programmes</h1>
        <p className="text-text-muted text-sm mt-2">Build an order-of-service booklet for a memorial or funeral.</p>
        <form onSubmit={create} className="bg-white border border-brand-dark rounded-2xl p-4 flex gap-2 my-6">
          <input required value={name} onChange={e => setName(e.target.value)} placeholder="Name of the deceased" className="flex-1 border border-brand-dark rounded-lg px-3 py-2 text-sm" />
          <button disabled={busy} className="px-4 py-2 rounded-lg bg-accent-navy text-white text-sm font-bold disabled:opacity-50">New programme</button>
        </form>
        {error && <p role="alert" className="text-red-600 text-sm mb-4">{error}</p>}
        <ul className="space-y-2">
          {list.map(p => <li key={p.id} className="bg-white border border-brand-dark rounded-xl px-4 py-3 flex justify-between">
            <span>{p.deceasedName ?? p.deceased_name ?? p.title ?? 'Untitled programme'}</span>
            <Link to={`/programme/edit/${p.id}`} className="text-accent-gold underline">Edit</Link>
          </li>)}
        </ul>
      </div>
    </div>
  );
}

export default function ProgrammeHome() {
  return <ProgrammeSignIn><HomeContent /></ProgrammeSignIn>;
}